import React from "react";
import { Typography, Button, Space, message } from "antd";

// result: object CCCD đã parse
export default function CccdResultInfo({ result, capturedImage, onRetake }) {
  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success("Copied to clipboard");
    } catch {}
  };

  return (
    <div
      className="qr-cccd-scanner__result"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div className="qr-cccd-scanner__result__image">
        {capturedImage ? (
          <img
            src={capturedImage}
            alt="CCCD"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 10,
            }}
          />
        ) : (
          <Typography.Text strong style={{ color: "#555", fontSize: 18 }}>
            Hình ảnh chụp được
          </Typography.Text>
        )}
      </div>
      <div className="qr-cccd-scanner__result__info">
        <Space direction="vertical" size={8}>
          {result ? (
            <>
              <div className="citizen-card">
                <div className="header-info">
                  <div className="badge-cccd">Số CCCD</div>
                  <div
                    onClick={() => handleCopy(result.cccdNumber)}
                    className="cccd-number"
                  >
                    {result.cccdNumber}
                  </div>
                </div>

                <div className="field">
                  <span className="label">Số CMND</span>
                  <span
                    onClick={() => handleCopy(result.cmndNumber)}
                    className="value"
                  >
                    {result.cmndNumber}
                  </span>
                </div>

                <div className="field">
                  <span className="label">Họ và tên</span>
                  <span
                    onClick={() => handleCopy(result.fullName)}
                    className="value"
                  >
                    {result.fullName}
                  </span>
                </div>

                <div className="row">
                  <div className="field">
                    <span className="label">Giới tính</span>
                    <span
                      onClick={() => handleCopy(result.gender)}
                      className="value"
                    >
                      {result.gender}
                    </span>
                  </div>
                  <div className="field">
                    <span className="label">Ngày sinh</span>
                    <span
                      onClick={() => handleCopy(result.dob)}
                      className="value"
                    >
                      {result.dob}
                    </span>
                  </div>
                </div>

                <div className="field">
                  <span className="label">Nơi thường trú</span>
                  <span
                    onClick={() => handleCopy(result.address)}
                    className="value"
                  >
                    {result.address}
                  </span>
                </div>

                <div className="field">
                  <span className="label">Ngày cấp CCCD</span>
                  <span
                    onClick={() => handleCopy(result.createdAt)}
                    className="value"
                  >
                    {result.createdAt}
                  </span>
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                background: "#fafafa",
                borderRadius: 7,
                textAlign: "center",
                padding: 18,
                color: "#888",
              }}
            >
              <Typography.Text>
                Chưa có dữ liệu CCCD, vui lòng quét mã QR.
              </Typography.Text>
            </div>
          )}
        </Space>
      </div>
      {onRetake && (
        <Button style={{ marginTop: 12 }} onClick={onRetake}>
          Chụp lại / Đổi ảnh
        </Button>
      )}
    </div>
  );
}
